<template>

      <div class="card"  v-bind="{...$attrs}">
           <slot>

          </slot>
        <h2 class="pay-title">
             <div >
                 <span v-show="cardData.title"  class="title" :title="cardData.title">
                    {{cardData.title}}
                 </span>
                  <span v-show="cardData.taxCompanyName"  class="title" :title="cardData.taxCompanyName">
                     {{cardData.taxCompanyName}}
                 </span>
                 <span  v-if="cardData.keys">
                             <span v-for="key in cardData.keys.slice(0,3)" :title="key|bspTableFilter({'1':'dict', '2':dicts}) " class="key key-item" :key="key" v-show="key">{{key|bspTableFilter({'1':'dict', '2':dicts})}}</span>
                             <span v-show="cardData.keys.length>3" :title="mapKeys">...</span>
                 </span>
                <span v-else style="color: transparent">1</span>
               <span class="key" v-if="cardData.taxReportStatus">{{cardData.taxReportStatus|bspTableFilter({'1':'dict', '2':dicts})}}</span>
               <span class="key" v-if="cardData.taxPayStatus">{{cardData.taxPayStatus|bspTableFilter({'1':'dict', '2':dicts})}}</span>
               <span class="key" v-if="cardData.taxPart">{{cardData.taxPart|bspTableFilter({'1':'dict', '2':dicts})}}</span>
               <span class="key" v-if="cardData.declareType">{{cardData.declareType|bspTableFilter({'1':'dict', '2':dicts})}}</span>
             </div>
              <div>
                <span  v-if="cardData.taxMonth" style="direction: rtl">{{cardData.taxMonth|bspTableFilter({'1':'dict', '2':dicts})}}</span>
              </div>
             <div v-if="cardData.state">

                <img v-if="filterStr(cardData.state,'9253')=='发放中'" src="@/assets/img/salary/fafang.svg">
								<img v-else-if="filterStr(cardData.state,'9253')=='不发放'" src="@/assets/img/salary/fafangzhong.svg">
								<img v-else-if="filterStr(cardData.state,'9253')=='待发放'" src="@/assets/img/salary/daifafang.svg">
								<img v-else-if="filterStr(cardData.state,'9253')=='暂缓发放'" src="@/assets/img/salary/zanhuanfafang.svg">
								<img v-else-if="filterStr(cardData.state,'9253')=='有退票'" src="@/assets/img/salary/youtuipiao.svg">
								<img v-else src="@/assets/img/salary/fafangwancheng.svg">
                <span class="word">{{cardData.state|bspTableFilter({'1':'dict', '2':dicts})}}</span>
             </div>
                <!--<div v-if="cardData.taxReportTime">
                 <span style="color:#666">{{cardData.taxReportTime}}</span>
             </div>-->

         </h2>
        <div class="carContent">
             <p v-if="cardData.taxType" class="type">报税类型包含：<span>{{cardData.taxType|bspTableFilter({'1':'dict', '2':dicts})}}<!--{{cardData.taxType}}--></span></p>
            <ul>
                 <li v-for="(label,i) in labels" :key="i">
                     <span>{{label}}：</span>
										 <span v-if="!cardData.info&&i==0">{{cardData.pernums}}</span>
										 <span v-if="!cardData.info&&i==1">{{cardData.taxAccount}}</span>
										 <span v-if="!cardData.info&&i==2">{{cardData.payAccount}}</span>
										 <span v-if="i!=4&&cardData.info">{{cardData.info[i]}}</span>

                     <span v-if="i==4&&cardData.info">
											  <el-tooltip v-if="filterStr(cardData.info[i],'9250')=='线下发薪'" class="item" effect="light" content="生成银行报盘文件 导入网银发薪" placement="left">
													<img src="@/assets/img/salary/yiwen.png"  style="vertical-align: middle;margin-right:10px;"/>
												</el-tooltip>
											 <el-tooltip v-if="filterStr(cardData.info[i],'9250')=='系统发薪'" class="item" effect="light" content="直联银行代发平台发薪" placement="left">
											 	<img src="@/assets/img/salary/yiwen.png"  style="vertical-align: middle;margin-right:10px;"/>
											 </el-tooltip>
											 <el-tooltip v-if="filterStr(cardData.info[i],'9250')=='中智发薪'" class="item" effect="light" content="中智发薪" placement="left">
											 	<img src="@/assets/img/salary/yiwen.png"  style="vertical-align: middle;margin-right:10px;"/>
											 </el-tooltip>

											 {{cardData.info[i]|bspTableFilter({'1':'dict', '2':dicts})}}</span>
                 </li>
             </ul>

         </div>
        <div class="info" v-if="cardData.grantInfo">
             <div v-if="cardData.grantInfo.num1">
                 <img src="@/assets/img/salary/fafangwancheng-xiao.png" style="margin-left:0;" />
                 <span>发放完成：</span>
                 <span>{{cardData.grantInfo.num1}}人</span>
             </div>
              <div v-if="cardData.grantInfo.num2">
                 <img src="@/assets/img/salary/icon-bufa.png" />
                 <span>不发：</span>
                 <span>{{cardData.grantInfo.num2}}人</span>
                  <span style="margin-left:18px;">暂缓发放：</span>
                 <span>{{cardData.grantInfo.num3}}人</span>
             </div >
              <div v-if="cardData.grantInfo.num4">
                 <img src="@/assets/img/salary/icon-tuipiao.png" />
                 <span>退票：</span>
                 <span>{{cardData.grantInfo.num4}}人，请及时处理</span>
             </div>
         </div>

      </div>

</template>

<script>
  import { mapGetters } from 'vuex';
  import store from "@/store";
  import {bspTableFilter} from "../../filters";
  export default {
    name: "card",
    computed: {
      ...mapGetters([
        'dicts',
      ]),
      mapKeys(){
       return  this.cardData.keys.map(item=>{
          return  bspTableFilter(item,({'1':'dict', '2':this.dicts}))
        })
      }
    },
    props: {
        cardData: {
            type: Object,
            default: {},
        },
        radio:{
            type: String,
            default: '1',
        },
        labels:{
             type: Array,
            default: [],
        },
         keys:{
             type: Array,
            default: [],
        }
    },
    data() {
      return {
         form:{
             radio:'1',
             adv:''
         }
      };
    },
    methods: {
			filterStr(val,dict){
				if(!val){
					return '';
				}
				return this.$store.getters.dicts.codeList[dict].filter(res=>{
							if(res.codeItemId==val){
								return res.codeItemName
							}
				})[0].codeItemName
			}
    }
  };
</script>

<style scoped >
	.card {
		border: 1px solid rgba(255, 255, 255, 1);
		box-shadow: 0px 1px 5px 0px rgba(203, 201, 201, 0.5);
		border-radius: 4px;
		box-sizing: border-box;
		 width:calc(50% - 10px);
		 /* max-width: 580px; */
		 min-width: 500px;
		/*min-width: 380px; */
		margin-right: 20px;
		margin-bottom: 20px;
		min-height: auto;
		background: #fff;
		position: relative;
		overflow: hidden;
	}
	.card:nth-of-type(2n){
		margin-right: 0;
	}
	h2>div>.word{
		font-size:13px;
font-family:PingFangSC-Medium,PingFang SC;
font-weight:500;
color:rgba(51,51,51,1);
margin-left: 10px;
	}
.type{
font-size:13px;
font-weight:400;
color:rgba(51,51,51,1);
line-height:18px;
padding:10px 0 20px;
}
.type>span{
    font-size:12px;
font-weight:400;
color:rgba(102,102,102,1);
line-height:17px;
}
    h2{
      display:flex;
      justify-content: space-between;
      flex-wrap: wrap;
      align-items: center;
      border-bottom: 4px solid #F3F3F3;
      height: 36px;
      line-height: 1.5;
      padding: 6px 14px 14px 20px;

    }
    h2>div>span{
            vertical-align: middle;
    }
    h2>div:nth-of-type(2)>span{
        font-size:13px;
        font-weight:500;
        color:rgba(51,51,51,1);
        line-height:18px;
        padding-left:10px;
    }
    .title{
			display: inline-block;
        font-size:16px;
        font-weight:500;
        color:rgba(51,51,51,1);
        line-height:22px;
         margin-right:8px;
				 max-width: 170px;
				 overflow: hidden;
				 text-overflow: ellipsis;
				 white-space: nowrap;
    }
    h2>div>.key{
        border-radius:2px;
        padding:1px 4px;
        font-size:10px;
        font-weight:300;
        line-height:14px;
        margin-left:5px;

    }
  .pay-title .key-item{
      border-radius:2px;
      padding:1px 4px;
      font-size:10px;
      font-weight:300;
      line-height:14px;
      margin-left:5px;
      width: 70px;
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: center;
    }
  .pay-title .key-item:nth-of-type(1){
    border:1px solid rgba(255,0,0,1);
    color:rgba(255,0,0,1)
  }
  .pay-title .key-item:nth-of-type(2){
    border:1px solid rgba(1,167,59,1);
    color:rgba(1,167,59,1);
  }
  .pay-title .key-item:nth-of-type(3){
    border:1px solid rgba(40,166,205,1);
    color: rgb(40,166,210);
  }
    h2>div>.key:nth-of-type(2){
        border:1px solid rgba(255,0,0,1);
        color:rgba(255,0,0,1)
    }
       h2>div>.key:nth-of-type(3){
        border:1px solid rgba(1,167,59,1);
        color:rgba(1,167,59,1);
    }
      h2>div>.key:nth-of-type(4){
        border:1px solid #E8E8E8;
        background:#E8E8E8;
    }
      h2>div>.key{
        border:1px solid rgba(40,166,205,1);
        color: rgb(40,166,210);
      }

    .carContent{
        padding:15px 100px 15px 21px;
    }
    .carContent li{
        height:25px;
        line-height:25px;
        background:rgba(240,240,240,1);
        border-radius:4px;
        margin-bottom:5px;
        display:flex;
        justify-content: space-between;
           align-items: center;
    }
    .carContent li span:nth-of-type(1){
    font-size:13px;
font-weight:400;
color:rgba(51,51,51,1);
line-height:18px;
padding-left:10px;
display:inline-block;
width:75px;
text-align:right;
white-space: nowrap;
    }

        .carContent li span:nth-of-type(2){
                font-size:13px;
font-family:PingFangSC-Medium,PingFang SC;
font-weight:500;
color:rgba(51,51,51,1);
line-height:18px;
padding-right:20px;

    }
    .info{
          display:flex;
          padding-left:25px;
          align-items: center;
    }
     .info>div{
         height:24px;
         line-height:24px;
     }
    .info span{
        font-size:13px;
font-family:PingFangSC-Medium,PingFang SC;
font-weight:500;
color:#666;
line-height:18px;
    vertical-align: middle;
    }
    .info img{
  vertical-align: middle;
  margin-right:9px;
  margin-left:30px;
    }


</style>
